export default "__VITE_ASSET__DhhQwGGN__"